export default "__VITE_ASSET__DtgtUwjH__"